import { render, staticRenderFns } from "./ReportHc.vue?vue&type=template&id=28928594"
import script from "./ReportHc.vue?vue&type=script&lang=js"
export * from "./ReportHc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports